var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4376 4.41998C9.47913 3.47812 8.21794 2.89198 6.86896 2.76142C5.51998 2.63086 4.16666 2.96397 3.03959 3.70398C1.91253 4.44399 1.08145 5.54513 0.687964 6.81976C0.294481 8.0944 0.362936 9.46367 0.881668 10.6943C1.4004 11.9249 2.33731 12.9406 3.53277 13.5685C4.72822 14.1964 6.10825 14.3976 7.43771 14.1377C8.76718 13.8779 9.96382 13.1731 10.8237 12.1434C11.6837 11.1138 12.1342 9.82302 12.1342 8.49103H9.85072C9.85072 9.30389 9.58337 10.0916 9.05859 10.7199C8.53381 11.3483 7.80355 11.7784 6.99223 11.937C6.18091 12.0956 5.33873 11.9728 4.60919 11.5896C3.87965 11.2065 3.30789 10.5866 2.99133 9.83557C2.67477 9.08459 2.633 8.24898 2.87312 7.47112C3.11325 6.69326 3.62042 6.02128 4.30823 5.56968C4.99603 5.11808 5.82191 4.9148 6.64514 4.99447C7.46837 5.07415 8.23802 5.43185 8.82295 6.00663L10.4376 4.41998Z",
    fill: "url(#paint0_linear_2173_7468)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29064 12.0147C7.51061 12.0147 8.70015 12.3889 9.69329 13.0851C10.6864 13.7813 11.4337 14.7648 11.8307 15.8983C12.2277 17.0318 12.2548 18.2589 11.908 19.4083C11.5613 20.5576 10.8581 21.572 9.8966 22.3098C8.93506 23.0476 7.76312 23.472 6.5443 23.5239C5.32548 23.5758 4.12057 23.2526 3.09768 22.5993C2.07479 21.946 1.28495 20.9952 0.838347 19.8796C0.391746 18.764 0.310666 17.5393 0.606419 16.3763L2.82179 16.9202C2.6413 17.63 2.69078 18.3774 2.96332 19.0582C3.23587 19.739 3.71788 20.3192 4.34211 20.7179C4.96633 21.1166 5.70164 21.3139 6.44544 21.2822C7.18924 21.2505 7.90443 20.9915 8.49122 20.5412C9.07801 20.091 9.50713 19.472 9.71872 18.7705C9.93031 18.0691 9.9138 17.3203 9.67151 16.6286C9.42922 15.9368 8.97322 15.3366 8.36715 14.9118C7.76107 14.4869 7.03514 14.2585 6.29064 14.2585V12.0147Z",
    fill: "url(#paint1_linear_2173_7468)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5687 8.49103C21.5687 11.6707 18.9456 14.2484 15.7097 14.2484C12.4739 14.2484 9.85072 11.6707 9.85072 8.49103C9.85072 5.31134 12.4739 2.7337 15.7097 2.7337C18.9456 2.7337 21.5687 5.31134 21.5687 8.49103ZM12.1342 8.49103C12.1342 10.4315 13.735 12.0045 15.7097 12.0045C17.6844 12.0045 19.2852 10.4315 19.2852 8.49103C19.2852 6.55059 17.6844 4.97756 15.7097 4.97756C13.735 4.97756 12.1342 6.55059 12.1342 8.49103Z",
    fill: "url(#paint2_linear_2173_7468)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0022 1.6022C11.0022 2.22711 10.4867 2.7337 9.85072 2.7337C9.21478 2.7337 8.69924 2.22711 8.69924 1.6022C8.69924 0.977292 9.21478 0.470703 9.85072 0.470703C10.4867 0.470703 11.0022 0.977292 11.0022 1.6022Z",
    fill: "url(#paint3_linear_2173_7468)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34824 15.0138C3.34824 15.6387 2.83271 16.1453 2.19676 16.1453C1.56082 16.1453 1.04528 15.6387 1.04528 15.0138C1.04528 14.3889 1.56082 13.8823 2.19676 13.8823C2.83271 13.8823 3.34824 14.3889 3.34824 15.0138Z",
    fill: "url(#paint4_linear_2173_7468)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_7468",
    x1: 19.1781,
    y1: -2.23737,
    x2: 0.893688,
    y2: 25.3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2173_7468",
    x1: 19.1781,
    y1: -2.23737,
    x2: 0.893688,
    y2: 25.3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2173_7468",
    x1: 19.1781,
    y1: -2.23737,
    x2: 0.893688,
    y2: 25.3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2173_7468",
    x1: 19.1781,
    y1: -2.23737,
    x2: 0.893688,
    y2: 25.3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2173_7468",
    x1: 19.1781,
    y1: -2.23737,
    x2: 0.893688,
    y2: 25.3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.0abf2843aea41497ab3d5bc39db7587d.svg";
export { ForwardRef as ReactComponent };